import React, { useEffect, useState } from 'react'
import {
  Box,
  Divider,
  Grid,
  Typography,
  styled,
  TextField,
  Card,
  CardActionArea,
  CardContent
} from '@mui/material'
import { Book, AdfScanner } from '@mui/icons-material'
import FilterButton from '../../components/buttons/FilterButton'
import DefaultPainel from '../../components/shared/Painel'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import TableHeader from '../../components/shared/tables/TableHeader'
import { Exemplares, Jasper } from '../../services/http'
import ApprovedChip from '../../components/shared/ApprovedChip'
import gerarPaginacao from '../../services/pagination'
import BaseFilter from '../../components/BaseFilter'
import BasicDatagrid from '../../components/shared/tables/BasicDatagrid'
import filter from './filters'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const StyledTextField = styled(TextField)(() => ({
  width: '100%'
}))

const QrCodeTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal'
  }
}))

const Qrcode = () => {
  const [rows, setRows] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [lastPage, setLastPage] = useState(1)
  const [tloading, setTloading] = useState(false)
  const [queryTitle, setQueryTitle] = useState([])
  const [query, setQuery] = useState({})
  const [itemTable, setItemTable] = useState([])
  const [linhas, setLinhas] = useState([])

  const columns = [
    {
      field: 'codExemplar',
      headerName: 'Código',
      flex: 1
    },
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1
    },
    {
      field: 'titulo',
      headerName: 'Exemplar',
      flex: 6
    },
    {
      field: 'formatoExemplar',
      headerName: 'Formato',
      flex: 1
    },
    {
      field: 'statusExemplar',
      headerName: 'Status',
      flex: 1,
      renderCell: ({ row }) => {
        const status = row.statusExemplar
        return <ApprovedChip value={status} />
      }
    }
  ].map(item => ({ ...item, headerClassName: 'jaostyle', sortable: false }))

  const getObras = async () => {
    const { data } = await Exemplares().show({
      per_page: -1,
      includes: ['obra', 'biblioteca', 'formatoExemplar', 'statusExemplar']
    })
    const aux = data.data.map(item => ({
      ...item,
      id: item.id,
      codExemplar: item.id,
      biblioteca: item.biblioteca.apelido,
      titulo: item.obra.titulo,
      formatoExemplar: item.formato_exemplar.descricao,
      statusExemplar: item.status_exemplar.descricao
    }))
    setLinhas(aux)
  }

  const buscarObras = async (filters = {}, page = 1) => {
    setTloading(true)
    const { data } = await Exemplares().show({
      page,
      per_page: 5,
      includes: ['obra', 'biblioteca', 'formatoExemplar', 'statusExemplar'],
      ...filters
    })

    setLastPage(data.last_page)
    setCurrentPage(data.current_page)
    setTloading(false)
    const aux = data.data.map(item => ({
      ...item,
      id: item.id,
      codExemplar: item.id,
      biblioteca: item.biblioteca.apelido,
      titulo: item.obra.titulo,
      formatoExemplar: item.formato_exemplar.descricao,
      statusExemplar: item.status_exemplar.descricao
    }))
    setRows(aux)
  }

  let typingTimer = ''

  const getExemplarTitle = () => {
    setQuery(
      Object.assign(query, { 'includes[obra][titulo]': `%${queryTitle}%` })
    )
    buscarObras(query)
  }

  const handleClean = () => {
    if (queryTitle !== '') {
      setQueryTitle('')
      delete query['includes[obra][titulo]']
      buscarObras({ ...query, 'includes[obra][titulo]': undefined })
    }
  }

  const init = async () => {
    buscarObras()
    getObras()
    setRows([])
  }

  const onRowsSelectionHandler = ids => {
    const selectedRowsData = ids.map(id =>
      linhas.find(linha => linha.id === id)
    )
    setItemTable(selectedRowsData)
  }

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => buscarObras(query, value)
  )

  const printOut = async () => {
    const codExemplar = itemTable.map(item => item.codExemplar)
    const { data } = await Jasper().QrCode().get({ exemplares: codExemplar })
    generatePdf(data)
  }

  const generatePdf = data => {
    const blob = new Blob([data], { type: 'application/pdf' })
    const blobURL = URL.createObjectURL(blob)
    window.open(blobURL)
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <Box>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Exemplares"
              controls={
                <MobileFilterHeaderContainer>
                  <StyledTextField
                    type="text"
                    color="white"
                    placeholder="Título"
                    size="small"
                    variant="standard"
                    onKeyDown={() => {
                      clearTimeout(typingTimer)
                    }}
                    onKeyUp={() => {
                      clearTimeout(typingTimer)
                      typingTimer = setTimeout(getExemplarTitle, 1000)
                    }}
                    onChange={({ target }) => {
                      setQueryTitle(target.value)
                    }}
                    value={queryTitle}
                    InputProps={{
                      style: { color: 'white' },
                      startAdornment: <SearchStartAdornment />,
                      endAdornment: <SearchEndAdornment action={handleClean} />
                    }}
                  />
                  <BaseFilter
                    filter={filter}
                    color="white"
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      buscarObras(query)
                    }}
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <QrCodeTable
                sx={{ height: '40vh !important' }}
                rows={rows}
                columns={columns}
                disableColumnMenu
                disableColumnSelector
                pagination={pagination}
                rowsPerPageOptions={[5]}
                pageSize={5}
                checkboxSelection
                keepNonExistentRowsSelected
                onSelectionModelChange={ids => {
                  onRowsSelectionHandler(ids)
                }}
                loading={tloading}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>

      {/* componentizar daqui para baixo */}

      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                ml: '24px',
                mb: '16px'
              }}
            >
              <Typography variant="h5"> Lista de impressão </Typography>
              <FilterButton
                onClick={() => {
                  printOut()
                }}
                text="Imprimir"
                Icon={AdfScanner}
                bg="#000000BF"
              />
            </Box>
            <Grid
              container
              rowSpacing={1}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                ml: '24px'
              }}
            >
              <Grid item xs={12} sm={12}>
                <Grid
                  container
                  spacing={3}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start'
                  }}
                >
                  {itemTable.map(value => {
                    return (
                      <>
                        <Grid xs={12} sm={3} item key={value?.codExemplar}>
                          <Card sx={{ maxWidth: 300 }} elevation={3}>
                            <CardActionArea>
                              <CardContent
                                sx={{
                                  height: '160px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'space-evenly'
                                }}
                              >
                                <Book color="primary" sx={{ fontSize: 60 }} />
                                <Typography variant="h8">
                                  {`${value?.codExemplar} - ${value?.titulo}`}
                                </Typography>
                              </CardContent>
                            </CardActionArea>
                          </Card>
                        </Grid>
                      </>
                    )
                  })}
                </Grid>
              </Grid>
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Qrcode
